import CustomTable from 'components/CustomTable'
import InputCustom from 'components/Inputs'
import useRedux from 'hooks/useRedux'
import { FiCheck, FiShuffle, FiAlertCircle } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap'
import { ApplicationState } from 'store'
import * as carteiraActions from 'store/modules/backoffice/carteira/actions'
import { CustomButton } from 'styles/global'
import { COLUMNS } from '../../constants/columnsShops'
import {
  HeaderModalContainer,
  HeaderModalSubTitle,
  HeaderModalTitle
} from '../../style'
import { CARTEIRA } from 'store/modules/backoffice/carteira/types'
import { LOADING } from 'store/modules/loading/types'
import { useEffect, useState } from 'react'

interface ShopListTypes {
  isOpen: boolean
  onToggle: () => void
  onSelect: () => void
}

const ShopListModal = ({ isOpen, onToggle, onSelect }: ShopListTypes) => {
  const { shopListModal, selectedLoja } = useSelector<
    ApplicationState,
    CARTEIRA
  >((state) => state.carteira)

  const { isLoading } = useSelector<ApplicationState, LOADING>(
    (state) => state.loading
  )

  const { dispatch } = useRedux()

  const [openNestedModal, setOpenNestedModal] = useState(false)
  const [selectedIds, setSelectedIds] = useState<string[]>([])
  const [search, setSearch] = useState('')
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formattedColumns, setformattedColumns] = useState<any>()

  function onChange(value: string) {
    setSearch(value)
  }

  function cleanSearch() {
    setSearch('')
  }

  function aplicarFiltros() {
    carteiraActions.getClientesPorLojaDispachSaga(shopListModal.lojaId)
  }

  function closeModal() {
    onToggle()
    setOpenNestedModal(false)
    dispatch(carteiraActions.cleanShopListModal())
    cleanSearch()
    dispatch(carteiraActions.setIdsTransferencia([]))
  }

  function handleSelectShop(e: string[]) {
    let selectedShop: string[] = []

    //condição criada para que seja possível a seleção de 1 linha só na tabela.

    if (e.length > 1) {
      const selectionSet = new Set(selectedIds)
      const result = e.filter((s) => !selectionSet.has(s))
      selectedShop = result
      setSelectedIds(result)
    } else {
      setSelectedIds(e)
      selectedShop = e
    }

    dispatch(carteiraActions.setIdsTransferencia(selectedShop))
  }

  function submitTransfer() {
    onSelect()
  }

  useEffect(() => {
    if (isOpen) {
      setOpenNestedModal(false)
      cleanSearch()
      dispatch(carteiraActions.setIdsTransferencia([]))
    }
  }, [dispatch, isOpen])

  useEffect(() => {
    setformattedColumns(
      shopListModal.lojas?.map((item) => ({
        id: item.lojaId,
        nomeLoja: item.nomeLoja,
        qtdClientesTotal: item.qtdClientesTotal
      }))
    )
  }, [shopListModal.lojas])

  function handleOpenNestedModal() {
    if (selectedIds.length === 0) {
      return
    }

    setOpenNestedModal(true)
  }

  return (
    <Modal size="xl" isOpen={isOpen} toggle={() => onToggle()}>
      <ModalHeader toggle={() => closeModal()}>
        <Row className="mb-4">
          <HeaderModalContainer>
            <FiShuffle size={24} color="var(--roxo-riber)" />
            <HeaderModalTitle>
              Transferir carteira de {selectedLoja.nome} para:
            </HeaderModalTitle>
          </HeaderModalContainer>
        </Row>

        <Row>
          <HeaderModalSubTitle>
            Os clientes serão divididos igualmente entre os selecionados
          </HeaderModalSubTitle>
        </Row>
      </ModalHeader>

      <ModalBody>
        <div className="container-fluid d-flex flex-column row-gap-10">
          <Row>
            <Col md={6}>
              <label className="label-12">Nome da loja</label>
              <InputCustom
                type="text"
                placeholder="Pesquise aqui"
                onChange={(e) => {
                  onChange(e.target.value)
                }}
                value={search}
              />
            </Col>
            <Col className="d-flex justify-content-end">
              <CustomButton
                onClick={() => handleOpenNestedModal()}
                isDisabled={selectedIds.length === 0}
              >
                <FiCheck size={20} />
                Transferir
              </CustomButton>
            </Col>
          </Row>

          {/* Nested Modal */}
          <Modal
            isOpen={openNestedModal}
            toggle={() => setOpenNestedModal(!openNestedModal)}
          >
            <ModalHeader>
              <FiAlertCircle color="var(--amarelo-riber)" />
              <HeaderModalTitle>Atenção!</HeaderModalTitle>
            </ModalHeader>

            <ModalBody>Deseja realmente realizar essa ação?</ModalBody>
            <ModalFooter>
              <CustomButton
                background="var(--roxo-riber)"
                onClick={() => setOpenNestedModal(false)}
              >
                Cancelar
              </CustomButton>
              <CustomButton onClick={() => submitTransfer()}>
                Confirmar
              </CustomButton>
            </ModalFooter>
          </Modal>
          {/* Nested Modal */}

          <Row className="my-2">
            <Col>
              <CustomButton
                onClick={() => aplicarFiltros()}
                background="var(--roxo-riber)"
              >
                Pesquisar
              </CustomButton>
            </Col>
          </Row>
          <Row>
            <CustomTable
              data={formattedColumns}
              columns={COLUMNS}
              paginationMode="client"
              checkboxSelection={true}
              selecteds={selectedIds}
              selectionModel={(e) => handleSelectShop(e)}
              isLoading={isLoading}
              disableSelectAllCheckbox
              disableSelectionOnClick={false}
              disableColumnFilter
              filterModel={{
                items: [
                  {
                    columnField: 'nomeLoja',
                    operatorValue: 'contains',
                    value: search
                  }
                ]
              }}
            />
          </Row>
        </div>
      </ModalBody>
    </Modal>
  )
}

export { ShopListModal }
